/**
 * JourneyCompleteScreen - Victory celebration
 */

import { useEffect, useState } from 'react';
import './JourneyCompleteScreen.css';

export default function JourneyCompleteScreen({ 
  stats, 
  completedLevels,
  totalLevels,
  onRestart, 
  onExit 
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setMounted(true));
  }, []);

  // Calculate play time
  const playTime = stats?.startTime 
    ? Math.round((Date.now() - stats.startTime) / 60000) 
    : 0;

  const phaseIcons = ['🎈', '🏃', '🔗', '📝', '📈', '💬', '🎯', '🗣️', '⭐', '🚀'];

  return (
    <div className={`journey-complete ${mounted ? 'mounted' : ''}`}>
      {/* Background effects */}
      <div className="journey-complete__bg">
        <div className="journey-complete__rays" />
        <div className="journey-complete__confetti">
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              className="journey-complete__confetti-piece"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
                animationDuration: `${3 + Math.random() * 2}s`,
                backgroundColor: ['#22c55e', '#fbbf24', '#38bdf8', '#f43f5e', '#8b5cf6'][Math.floor(Math.random() * 5)],
              }}
            />
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="journey-complete__content">
        {/* Trophy */}
        <div className="journey-complete__trophy">🏆</div>

        {/* Title */}
        <h1 className="journey-complete__title">Journey Complete!</h1>
        <p className="journey-complete__subtitle">You're a Speech Champion!</p>

        {/* Stats */}
        <div className="journey-complete__stats">
          <div className="journey-complete__stat">
            <span className="journey-complete__stat-value">{completedLevels?.length || 0}</span>
            <span className="journey-complete__stat-label">Levels</span>
          </div>
          <div className="journey-complete__stat">
            <span className="journey-complete__stat-value">{stats?.wordsSpoken || 0}</span>
            <span className="journey-complete__stat-label">Words</span>
          </div>
          <div className="journey-complete__stat">
            <span className="journey-complete__stat-value">{playTime}</span>
            <span className="journey-complete__stat-label">Minutes</span>
          </div>
        </div>

        {/* Phase icons */}
        <div className="journey-complete__phases">
          {phaseIcons.map((icon, i) => (
            <span 
              key={i} 
              className="journey-complete__phase-icon"
              style={{ animationDelay: `${1 + i * 0.1}s` }}
            >
              {icon}
            </span>
          ))}
        </div>

        {/* Message */}
        <p className="journey-complete__message">
          You've mastered all 10 phases of speech development!
        </p>

        {/* Buttons */}
        <div className="journey-complete__buttons">
          <button 
            className="journey-complete__btn journey-complete__btn--restart"
            onClick={onRestart}
          >
            Play Again
          </button>
          <button 
            className="journey-complete__btn journey-complete__btn--exit"
            onClick={onExit}
          >
            Back to Games
          </button>
        </div>
      </div>
    </div>
  );
}
